import React from 'react';
import PropTypes from 'prop-types';
import DsBanner from './bannerStatus';

const BannerThanks = ({
  className, booking, lang, loyalty, loggedUser,
}, context) => {
  const client = {
    name: booking ? booking.cli_full_name : '',
    email: booking ? booking.cli_email : '',
  };
  const hotelName = booking ? booking.hotel.name : '';
  const bookingStatus = booking ? booking.status_display : '';
  const customer = () => <span className="font-bold">{client.name}</span>;
  const bookStatus = () => (
          <span className="text-status-green">{bookingStatus.toLowerCase()}</span>
  );
  const hotel = () => <strong className="font-bold">{hotelName}</strong>;
  return (
    <DsBanner className={`text-lg bg-gray-100 shadow mx-4 my-6 ${className}`}
              booking={booking} lang={lang} loyalty={loyalty} loggedUser={loggedUser}>
      <div className="flex-grow-default">
        {/* Elimina dangerouslySetInnerHTML y usa JSX directamente */}
        <div>
          {context.t('Hello {customer}, your reservation is {bookStatus}', {
            customer: customer(),
            bookStatus: bookStatus(),
          })}
        </div>
        <p className="mb-2">
          {context.t('Thank you for choosing {hotel}', {
            hotel: hotel(),
          })}
          <br />
          {context.t('A confirmation e-mail has been sent to this e-mail address:')}
          <strong className="font-bold"> {client.email}</strong>
        </p>
      </div>
    </DsBanner>
  );
};

BannerThanks.contextTypes = {
  t: PropTypes.func.isRequired,
};
BannerThanks.propTypes = {
  booking: PropTypes.object.isRequired,
};

export default BannerThanks;
